import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface LoginForm {
  email: string
  password: string
}

export const LoginFormValues: LoginForm = {
  email: '',
  password: '',
}

export interface ILoginState {
  loginForm: LoginForm
  isModalOpen: boolean
}

const initialState: ILoginState = {
  loginForm: LoginFormValues,
  isModalOpen: false,
}

export const slice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    onLoginForm: (
      state: ILoginState,
      action: PayloadAction<typeof initialState.loginForm>
    ) => {
      state.loginForm = action.payload
    },
    onIsModalOpen: (
      state: ILoginState,
      action: PayloadAction<typeof initialState.isModalOpen>
    ) => {
      state.isModalOpen = action.payload
    },
  },
})

export const { actions, reducer } = slice

export type ILogin = {
  login: ILoginState
}
